<template>
      <v-row class="mb-2">
        <v-col cols="auto">
          <v-avatar color="#E7E7E7">{{initials}}</v-avatar>
        </v-col>
        <v-col>
          <v-card outlined>
            <v-card-title class="py-1 px-2">
              <span v-if="!isDescription"  class="text-caption font-weight-bold">
                {{author}}
              </span>
              &nbsp;
              <span class="text-caption font-weight-light">{{date}}</span>
            </v-card-title>
            <v-divider v-if="body"/>
            <v-card-text v-if="body">
              <span class="text--primary">{{body}}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
</template>

<script>
export default {
  name: "TranscriptQueueTaskNote",
  props: ["author", "body", 'created_on', 'isDescription'],
  computed: {
    initials() {
      return this.author.split(' ').map((name) => name[0]).join("");
    },
    date() {
      let date = new Date(this.created_on)
      return `${date.toDateString()} ${date.toLocaleTimeString()}`
    }
  }
};
</script>